import {
  PictogramRegularDermo as SgRecomendedByDermatologistsIcon,
  breakpoints,
  theme,
  PictogramRegularSummerBlackFriday,
  Link,
  PictogramRegularBlackFriday,
} from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const RecomendedByDermatologistsIcon = styled(
  SgRecomendedByDermatologistsIcon
)`
  width: 3.5rem;
  height: 3.5rem;

  ${theme.typography.labelSmall400};
  font-weight: 500;

  @media (min-width: ${breakpoints.md}) {
    width: 4rem;
    height: 4rem;
  }
`;

export const StyledSummerBlackFridayIcon = styled(
  PictogramRegularSummerBlackFriday
)`
  min-width: 3.75rem !important;
  height: 3.125rem;

  line-height: 0.9125rem;
  font-size: 0.725rem;

  @media (min-width: ${breakpoints.md}) {
    min-width: 4.063rem !important;
    height: 3.75rem;
  }
`;

export const StyledBlackFridayIcon = styled(PictogramRegularBlackFriday)`
  min-height: 48px;
  min-width: 48px !important;

  border-top: 0.3rem solid;
  line-height: 14px;
  font-size: 10px;

  @media (min-width: ${breakpoints.md}) {
    border-top: 0.4rem solid;
    line-height: 16px;
    font-size: 12px;
    min-height: 56px;
    min-width: 56px !important;
  }
`;

export const DermoLink = styled(Link)`
  cursor: pointer;
  width: fit-content;
`;
